import SubLabel from "components/Atoms/Sublabel";
import PickerList from "components/Picker/PickerList";
import React from "react";
import { PickerListProps } from "../props";
import { PhosphorWarning } from "components/Atoms/PhosphorIcon";
import CompanyContactList from "./CompanyContactList";

interface ContactListProps extends PickerListProps<server.dto.ContactSmallV2> {
  initialKeyword?: string;
  excludeKeys?: number[];
  fromCompanyId?: number;
}

const ContactList = (props: ContactListProps) => {
  const [showCompanyContacts, setShowCompanyContacts] = React.useState(props.fromCompanyId != null);

  const [instruction, setInstruction] = React.useState<server.dto.ListContactInstruction>({
    page: 1,
    perPage: 20,
    keyword: props.initialKeyword || "",
    excludeKeys: props.excludeKeys || []
  });

  if (showCompanyContacts && props.fromCompanyId != null) {
    return <CompanyContactList
      companyId={props.fromCompanyId}
      excludeKeys={props.excludeKeys}
      onItemSelected={props.onItemSelected}
      onSwitchToSearch={(keyword) => {
        setInstruction(prev => ({ ...prev, keyword, page: 1 }));
        setShowCompanyContacts(false);
      }}
    />;
  }

  return <PickerList
    instruction={instruction}
    onInstructionChange={setInstruction}
    queryKey="contactpickerlist"
    api={window.CoreApi.Contact.PaginatedSmall}
    onClick={props.onItemSelected}
    getError={() => undefined}
    excludeKeys={props.excludeKeys}
    getId={contact => contact.contactId}
    renderListItem={contact => <div className="flex">
      <div className="grow1">
        <div>{contact.name.fullName}</div>
        <SubLabel>{contact.position}</SubLabel>
      </div>

      {!contact.isValidated && (
        <div>
          <PhosphorWarning iconSize="large" />
        </div>)}
    </div>}
  />
};

export default ContactList;